import type { AgendaDay } from "#internal"

/** The day `index` days after the 1st of January of `year`, before it when
 * negative. */
export const AgendaDate = (year: number, index: number): AgendaDay => {
  const date = new Date(Date.UTC(year, 0, 1 + index))
  return {
    day: date.getUTCDate(),
    month: date.getUTCMonth() + 1,
    weekday: (date.getUTCDay() + 6) % 7,
    year: date.getUTCFullYear(),
  }
}
